import { App } from 'antd';

/**
 * 使用 Ant Design App 组件提供的 message 实例
 * 解决静态 message 方法无法消费 context 的告警
 */
export const useMessage = () => {
  const { message } = App.useApp();
  return message;
};

export default useMessage;